var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchService from "./Shared/FetchService";
import OpportunitySourceDomainService from "../Domain/OpportunitySource/OpportunitySource.service";
const BASE_URL = "/aviso/opportunitySource";
export default class OpportunitySourceService {
    static create(name, opportunitySourceCategoryId, active, description) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.postSingleResponse(BASE_URL + "/create", {
                name,
                opportunitySourceCategoryId,
                active,
                description,
            });
        });
    }
    static edit(opportunitySourceId, name, description, opportunitySourceCategoryId, active) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.postSingleResponse(BASE_URL + "/edit", {
                opportunitySourceId,
                name,
                description,
                opportunitySourceCategoryId,
                active,
            });
        });
    }
    static get(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.getSingleResponse(BASE_URL + "/get", {
                id,
            }).then(OpportunitySourceDomainService.fromJSON);
        });
    }
    static search(search, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const pagedResult = yield FetchService.getPagedResponse(BASE_URL + "/search", {
                names: search.names,
                descriptions: search.descriptions,
                opportunitySourceCategoryIds: search.opportunitySourceCategoryIds,
                active: search.active,
                query: search.query,
                modifiedByIds: search.modifiedByIds,
                createByIds: search.createByIds,
                createDateFrom: search.createDateFrom,
                createDateTo: search.createDateTo,
                modifiedDateFrom: search.modifiedDateFrom,
                modifiedDateTo: search.modifiedDateTo,
                sort: options.sort,
                max: options.max,
                offset: options.offset,
                order: options.order,
            });
            return Object.assign(Object.assign({}, pagedResult), { data: pagedResult.data.map(OpportunitySourceDomainService.fromJSON) });
        });
    }
    /*
     * Update a list of opportunities
     */
    static bulkUpdateOpportunitySource(opportunityIds, opportunitySourceId, pipelineId) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.postSingleResponse(BASE_URL + "/bulkUpdateOpportunitySource", {
                opportunityIds,
                opportunitySourceId,
                pipelineId,
            });
        });
    }
    static save(request) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.postSingleResponse(BASE_URL + "/save", request).then(OpportunitySourceDomainService.fromJSON);
        });
    }
}
